module.exports = __webpack_public_path__ + "img/tmenu3.29130573.png";